export default "__VITE_ASSET__Bbk_WbjL__"